import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import {
  AccordionDetails,
  AccordionSummary,
  Avatar,
  Grid2,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import AlertCircleIco from "../../../../assets/icons/AlertCircleIco";
import CheckIco from "../../../../assets/icons/CheckIco";
import DiscIco from "../../../../assets/icons/DiscIco";
import JigsawSkillsExperienceMatrix from "../../../../assets/icons/JigsawSkillsExperienceMatrix";
import CommonButton from "../../../../component/Button";
import {
  CommonGrid2,
  CustomAccordion,
  StyledFlexRowView,
} from "../../../common-components/StyledComponents";
import ShareQuickMatch from "../../quick-match/components/ShareQuickMatch";
import { CustomPaper } from "../../../resume-intelligence/Style";
import CandidateProximityInsight from "./components/CandidateProximityInsight";
import Interactions from "./components/Interactions";
import Results from "./components/Results";
import Skills from "./components/Skills";
import SummaryInteractionDialog from "./components/SummaryInteractionDialog";
import ExpandIco from "../../../../assets/icons/ExpandIco";
import { ReactComponent as CandidateChatBot } from "../../../../assets/images/CandidateChatBot.svg";
import CandidateFitIco from "../../../../assets/icons/CandidateFitIco";
import { CustomDiv } from "../../../chat-bot/style";

function JobsSummary() {
  const resultHeaderData = ["Candidate", "Status", "Score", ""];
  const interactionHeaderData = ["ID", "Type", "Action", "Date", "Made By", ""];

  // Static content
  const staticDragContent = [
    { id: 1, name: "John Doe", status: "Pending", score: 85 },
    { id: 2, name: "Jane Smith", status: "Selected", score: 90 },
    { id: 3, name: "Sam Wilson", status: "Rejected", score: 70 },
  ];

  const [dragContent, setDragContent] = useState(staticDragContent);
  const [lock, setLock] = useState({
    content: "UnLock",
    loading: false,
    error: false,
  });
  const [shareDialogOpen, setShareDialogOpen] = useState(false);
  const [interActionOpen, setInterActionOpen] = useState(false);
  const [interActionData, setInterActionData] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  const onDragEnd = (result) => {
    const { source, destination } = result;

    if (!destination || destination.index === source.index) return;

    const reorderedCandidates = [...dragContent];
    const [removed] = reorderedCandidates.splice(source.index, 1);
    reorderedCandidates.splice(destination.index, 0, removed);

    setDragContent(reorderedCandidates);
  };

  const handleShareDialogClose = () => setShareDialogOpen(false);
  const handleShareInvite = () => {
    alert("Invite Sent!");
    setShareDialogOpen(false);
  };

  const handleLock = (e) => {
    e.stopPropagation();
    setLock((prev) => ({
      ...prev,
      content: prev.content === "UnLock" ? "Lock" : "UnLock",
    }));
  };

  function FeedbackCard({ icon, message, marginBottom }) {
    return (
      // <CustomPaper
      //   variant="outlined"
      //   width="100%"
      //   padding={"12px"}
      //   marginBottom={marginBottom}
      //   display={"flex"}
      //   alignItems={"start"}
      // >
      //  <Avatar
      //     sx={{
      //       bgcolor: "transparent",
      //       marginRight: "4px",
      //       height: "25px !important",
      //     }}
      //   >
      //     {icon}
      //   </Avatar>
      <Typography
        sx={{
          fontSize: "15px",
          fontWeight: 500,
          color: "#667085",
          padding: "12px",
        }}
      >
        {message}
      </Typography>
    );
  }

  const accordionDataView = [
    {
      title: (
        <StyledFlexRowView>
          Results
          <Typography fontSize={"20px"} fontWeight={600} color={"#667085"}>
            · {dragContent.length}
          </Typography>
        </StyledFlexRowView>
      ),
      component: (
        <>
          <Results
            lock={lock}
            resultHeaderData={resultHeaderData}
            onDragEnd={onDragEnd}
            dragContent={dragContent}
          />
          <CommonGrid2 container spacing={3}>
            <CommonGrid2 style={{ paddingTop: "32px" }}>
              <CustomDiv border="1px solid #EAECF0" borderRadius={"8px"}>
                <CommonGrid2
                  display={"flex"}
                  alignItems={"center"}
                  gap={"10px"}
                  padding={"7px"}
                  borderBottom={"1px solid #EAECF0"}
                >
                  <div style={{ display: "flex" }}>
                    <svg
                      width="36"
                      height="36"
                      viewBox="0 0 36 36"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g filter="url(#filter0_d_10095_100267)">
                        <path
                          d="M8 1.5H28C31.0376 1.5 33.5 3.96243 33.5 7V27C33.5 30.0376 31.0376 32.5 28 32.5H8C4.96243 32.5 2.5 30.0376 2.5 27V7C2.5 3.96243 4.96243 1.5 8 1.5Z"
                          stroke="#EAECF0"
                          shape-rendering="crispEdges"
                        />
                        <path
                          d="M20.667 11.6668C21.287 11.6668 21.597 11.6668 21.8513 11.735C22.5415 11.9199 23.0806 12.459 23.2655 13.1492C23.3337 13.4035 23.3337 13.7135 23.3337 14.3335V20.4668C23.3337 21.5869 23.3337 22.147 23.1157 22.5748C22.9239 22.9511 22.618 23.2571 22.2416 23.4488C21.8138 23.6668 21.2538 23.6668 20.1337 23.6668H15.867C14.7469 23.6668 14.1868 23.6668 13.759 23.4488C13.3827 23.2571 13.0767 22.9511 12.885 22.5748C12.667 22.147 12.667 21.5869 12.667 20.4668V14.3335C12.667 13.7135 12.667 13.4035 12.7351 13.1492C12.9201 12.459 13.4592 11.9199 14.1494 11.735C14.4037 11.6668 14.7137 11.6668 15.3337 11.6668M16.4003 13.0002H19.6003C19.9737 13.0002 20.1604 13.0002 20.303 12.9275C20.4284 12.8636 20.5304 12.7616 20.5943 12.6362C20.667 12.4935 20.667 12.3069 20.667 11.9335V11.4002C20.667 11.0268 20.667 10.8401 20.5943 10.6975C20.5304 10.5721 20.4284 10.4701 20.303 10.4062C20.1604 10.3335 19.9737 10.3335 19.6003 10.3335H16.4003C16.027 10.3335 15.8403 10.3335 15.6977 10.4062C15.5722 10.4701 15.4702 10.5721 15.4063 10.6975C15.3337 10.8401 15.3337 11.0268 15.3337 11.4002V11.9335C15.3337 12.3069 15.3337 12.4935 15.4063 12.6362C15.4702 12.7616 15.5722 12.8636 15.6977 12.9275C15.8403 13.0002 16.027 13.0002 16.4003 13.0002Z"
                          stroke="#344054"
                          stroke-width="1.33333"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </g>
                      <defs>
                        <filter
                          id="filter0_d_10095_100267"
                          x="0"
                          y="0"
                          width="36"
                          height="36"
                          filterUnits="userSpaceOnUse"
                          color-interpolation-filters="sRGB"
                        >
                          <feFlood
                            flood-opacity="0"
                            result="BackgroundImageFix"
                          />
                          <feColorMatrix
                            in="SourceAlpha"
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            result="hardAlpha"
                          />
                          <feOffset dy="1" />
                          <feGaussianBlur stdDeviation="1" />
                          <feComposite in2="hardAlpha" operator="out" />
                          <feColorMatrix
                            type="matrix"
                            values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
                          />
                          <feBlend
                            mode="normal"
                            in2="BackgroundImageFix"
                            result="effect1_dropShadow_10095_100267"
                          />
                          <feBlend
                            mode="normal"
                            in="SourceGraphic"
                            in2="effect1_dropShadow_10095_100267"
                            result="shape"
                          />
                        </filter>
                      </defs>
                    </svg>
                  </div>

                  <Typography
                    fontSize={"19px"}
                    fontWeight={700}
                    color={"#101828"}
                  >
                    {"Overall Analysis"}
                  </Typography>
                </CommonGrid2>

                <FeedbackCard
                  message={
                    "This team is well-constructed for execution of a known strategic direction, with slightly less strength in frontline retail integration and deep personalization maturity. This team is highly likely to deliver a customer-focused digital platform on time and at scale. Its greatest strength lies in execution discipline and strategic clarity. To maximize impact, Macy’s should reinforce retail integration and advanced personalization capabilities to ensure the experience is not only delivered—but differentiated."
                  }
                  icon={<CheckIco />}
                  marginBottom="16px"
                />
              </CustomDiv>
            </CommonGrid2>
            <CommonGrid2 size={12}>
              <CustomDiv border="1px solid #EAECF0" borderRadius={"8px"}>
                <CommonGrid2
                  display={"flex"}
                  alignItems={"center"}
                  gap={"10px"}
                  padding={"7px"}
                  borderBottom={"1px solid #EAECF0"}
                >
                  <div style={{ display: "flex" }}>
                    <svg
                      width="36"
                      height="36"
                      viewBox="0 0 36 36"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g filter="url(#filter0_d_10095_100267)">
                        <path
                          d="M8 1.5H28C31.0376 1.5 33.5 3.96243 33.5 7V27C33.5 30.0376 31.0376 32.5 28 32.5H8C4.96243 32.5 2.5 30.0376 2.5 27V7C2.5 3.96243 4.96243 1.5 8 1.5Z"
                          stroke="#EAECF0"
                          shape-rendering="crispEdges"
                        />
                        <path
                          d="M20.667 11.6668C21.287 11.6668 21.597 11.6668 21.8513 11.735C22.5415 11.9199 23.0806 12.459 23.2655 13.1492C23.3337 13.4035 23.3337 13.7135 23.3337 14.3335V20.4668C23.3337 21.5869 23.3337 22.147 23.1157 22.5748C22.9239 22.9511 22.618 23.2571 22.2416 23.4488C21.8138 23.6668 21.2538 23.6668 20.1337 23.6668H15.867C14.7469 23.6668 14.1868 23.6668 13.759 23.4488C13.3827 23.2571 13.0767 22.9511 12.885 22.5748C12.667 22.147 12.667 21.5869 12.667 20.4668V14.3335C12.667 13.7135 12.667 13.4035 12.7351 13.1492C12.9201 12.459 13.4592 11.9199 14.1494 11.735C14.4037 11.6668 14.7137 11.6668 15.3337 11.6668M16.4003 13.0002H19.6003C19.9737 13.0002 20.1604 13.0002 20.303 12.9275C20.4284 12.8636 20.5304 12.7616 20.5943 12.6362C20.667 12.4935 20.667 12.3069 20.667 11.9335V11.4002C20.667 11.0268 20.667 10.8401 20.5943 10.6975C20.5304 10.5721 20.4284 10.4701 20.303 10.4062C20.1604 10.3335 19.9737 10.3335 19.6003 10.3335H16.4003C16.027 10.3335 15.8403 10.3335 15.6977 10.4062C15.5722 10.4701 15.4702 10.5721 15.4063 10.6975C15.3337 10.8401 15.3337 11.0268 15.3337 11.4002V11.9335C15.3337 12.3069 15.3337 12.4935 15.4063 12.6362C15.4702 12.7616 15.5722 12.8636 15.6977 12.9275C15.8403 13.0002 16.027 13.0002 16.4003 13.0002Z"
                          stroke="#344054"
                          stroke-width="1.33333"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </g>
                      <defs>
                        <filter
                          id="filter0_d_10095_100267"
                          x="0"
                          y="0"
                          width="36"
                          height="36"
                          filterUnits="userSpaceOnUse"
                          color-interpolation-filters="sRGB"
                        >
                          <feFlood
                            flood-opacity="0"
                            result="BackgroundImageFix"
                          />
                          <feColorMatrix
                            in="SourceAlpha"
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            result="hardAlpha"
                          />
                          <feOffset dy="1" />
                          <feGaussianBlur stdDeviation="1" />
                          <feComposite in2="hardAlpha" operator="out" />
                          <feColorMatrix
                            type="matrix"
                            values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
                          />
                          <feBlend
                            mode="normal"
                            in2="BackgroundImageFix"
                            result="effect1_dropShadow_10095_100267"
                          />
                          <feBlend
                            mode="normal"
                            in="SourceGraphic"
                            in2="effect1_dropShadow_10095_100267"
                            result="shape"
                          />
                        </filter>
                      </defs>
                    </svg>
                  </div>

                  <Typography
                    fontSize={"19px"}
                    fontWeight={700}
                    color={"#101828"}
                  >
                    {"Key Strengths"}
                  </Typography>
                </CommonGrid2>

                <Typography
                  fontSize={"15px"}
                  fontWeight={700}
                  marginLeft={"10px"}
                  marginTop={"10px"}
                >
                  1. Clear Vision + Strong Execution Backbone
                </Typography>

                <ul style={{ marginTop: "0px" }}>
                  <li style={{ color: "#344054", fontSize: "15px" }}>
                    Zahir sets a compelling customer-first north star
                  </li>
                  <li style={{ color: "#344054", fontSize: "15px" }}>
                    Jacob and Lana ensure momentum, discipline, and delivery
                    certainty
                  </li>
                </ul>

                <Typography
                  fontSize={"15px"}
                  fontWeight={700}
                  marginLeft={"10px"}
                >
                  2. Excellent Delivery Capacity
                </Typography>
                <ul style={{ marginTop: "0px" }}>
                  <li style={{ color: "#344054", fontSize: "15px" }}>
                    Dual execution leads reduce single-point failure risk
                  </li>
                  <li style={{ color: "#344054", fontSize: "15px" }}>
                    High likelihood of hitting timelines and scope commitments
                  </li>
                </ul>
                <Typography
                  fontSize={"15px"}
                  fontWeight={700}
                  marginLeft={"10px"}
                >
                  3. Solid Product & Experience Thinking
                </Typography>

                <ul style={{ marginTop: "0px" }}>
                  <li style={{ color: "#344054", fontSize: "15px" }}>
                    Phoenix ensures the app doesn’t devolve into a feature-dump
                  </li>
                  <li style={{ color: "#344054", fontSize: "15px" }}>
                    Strong alignment to customer journeys rather than internal
                    silos
                  </li>
                </ul>
              </CustomDiv>
            </CommonGrid2>

            {/* Gap Skill */}
            <CommonGrid2 size={12}>
              <CustomDiv border="1px solid #EAECF0" borderRadius={"8px"}>
                <CommonGrid2
                  display={"flex"}
                  alignItems={"center"}
                  gap={"10px"}
                  padding={"7px"}
                  borderBottom={"1px solid #EAECF0"}
                >
                  <div style={{ display: "flex" }}>
                    <svg
                      width="36"
                      height="36"
                      viewBox="0 0 36 36"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g filter="url(#filter0_d_10095_100273)">
                        <path
                          d="M8 1.5H28C31.0376 1.5 33.5 3.96243 33.5 7V27C33.5 30.0376 31.0376 32.5 28 32.5H8C4.96243 32.5 2.5 30.0376 2.5 27V7C2.5 3.96243 4.96243 1.5 8 1.5Z"
                          stroke="#EAECF0"
                          shape-rendering="crispEdges"
                        />
                        <g clip-path="url(#clip0_10095_100273)">
                          <path
                            d="M19.9997 15.0002L15.9997 19.0002M15.9997 15.0002L19.9997 19.0002M24.6663 17.0002C24.6663 20.6821 21.6816 23.6668 17.9997 23.6668C14.3178 23.6668 11.333 20.6821 11.333 17.0002C11.333 13.3183 14.3178 10.3335 17.9997 10.3335C21.6816 10.3335 24.6663 13.3183 24.6663 17.0002Z"
                            stroke="#344054"
                            stroke-width="1.33333"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </g>
                      </g>
                      <defs>
                        <filter
                          id="filter0_d_10095_100273"
                          x="0"
                          y="0"
                          width="36"
                          height="36"
                          filterUnits="userSpaceOnUse"
                          color-interpolation-filters="sRGB"
                        >
                          <feFlood
                            flood-opacity="0"
                            result="BackgroundImageFix"
                          />
                          <feColorMatrix
                            in="SourceAlpha"
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            result="hardAlpha"
                          />
                          <feOffset dy="1" />
                          <feGaussianBlur stdDeviation="1" />
                          <feComposite in2="hardAlpha" operator="out" />
                          <feColorMatrix
                            type="matrix"
                            values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
                          />
                          <feBlend
                            mode="normal"
                            in2="BackgroundImageFix"
                            result="effect1_dropShadow_10095_100273"
                          />
                          <feBlend
                            mode="normal"
                            in="SourceGraphic"
                            in2="effect1_dropShadow_10095_100273"
                            result="shape"
                          />
                        </filter>
                        <clipPath id="clip0_10095_100273">
                          <rect
                            width="16"
                            height="16"
                            fill="white"
                            transform="translate(10 9)"
                          />
                        </clipPath>
                      </defs>
                    </svg>
                  </div>

                  <Typography
                    fontSize={"19px"}
                    fontWeight={700}
                    color={"#101828"}
                  >
                    {"Gaps & Risks"}
                  </Typography>
                </CommonGrid2>

                <Typography
                  fontSize={"15px"}
                  fontWeight={700}
                  marginLeft={"10px"}
                  marginTop={"10px"}
                >
                  1. Store & Omnichannel Reality Gap
                </Typography>

                <ul style={{ marginTop: "0px" }}>
                  <li style={{ color: "#344054", fontSize: "15px" }}>
                    No clear owner for store operations integration
                  </li>
                  <li style={{ color: "#344054", fontSize: "15px" }}>
                    Risk: Digital experience doesn’t align with in-store
                    execution
                  </li>
                </ul>

                <Typography
                  fontSize={"15px"}
                  fontWeight={700}
                  marginLeft={"10px"}
                >
                  2. Advanced Personalization & AI Depth
                </Typography>
                <ul style={{ marginTop: "0px" }}>
                  <li style={{ color: "#344054", fontSize: "15px" }}>
                    Analytics capability exists but may skew descriptive vs
                    predictive
                  </li>
                  <li style={{ color: "#344054", fontSize: "15px" }}>
                    Risk: “Customer-first” feels generic rather than
                    differentiated
                  </li>
                </ul>
                <Typography
                  fontSize={"15px"}
                  fontWeight={700}
                  marginLeft={"10px"}
                >
                  3. Change Fatigue Risk
                </Typography>

                <ul style={{ marginTop: "0px" }}>
                  <li style={{ color: "#344054", fontSize: "15px" }}>
                    Adoption depends heavily on Sophia’s influence
                  </li>
                  <li style={{ color: "#344054", fontSize: "15px" }}>
                    Without strong executive reinforcement, field adoption may
                    lag
                  </li>
                </ul>
              </CustomDiv>
            </CommonGrid2>

            {/* Recommendations */}
            <CommonGrid2 size={12}>
              <CustomDiv border="1px solid #EAECF0" borderRadius={"8px"}>
                <CommonGrid2
                  display={"flex"}
                  alignItems={"center"}
                  gap={"10px"}
                  padding={"7px"}
                  borderBottom={"1px solid #EAECF0"}
                >
                  <div style={{ display: "flex" }}>
                    <svg
                      width="36"
                      height="36"
                      viewBox="0 0 36 36"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g filter="url(#filter0_d_10095_100279)">
                        <path
                          d="M8 1.5H28C31.0376 1.5 33.5 3.96243 33.5 7V27C33.5 30.0376 31.0376 32.5 28 32.5H8C4.96243 32.5 2.5 30.0376 2.5 27V7C2.5 3.96243 4.96243 1.5 8 1.5Z"
                          stroke="#EAECF0"
                          shape-rendering="crispEdges"
                        />
                        <g clip-path="url(#clip0_10095_100279)">
                          <path
                            d="M19.9997 15.0002L15.9997 19.0002M15.9997 15.0002L19.9997 19.0002M24.6663 17.0002C24.6663 20.6821 21.6816 23.6668 17.9997 23.6668C14.3178 23.6668 11.333 20.6821 11.333 17.0002C11.333 13.3183 14.3178 10.3335 17.9997 10.3335C21.6816 10.3335 24.6663 13.3183 24.6663 17.0002Z"
                            stroke="#344054"
                            stroke-width="1.33333"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </g>
                      </g>
                      <defs>
                        <filter
                          id="filter0_d_10095_100279"
                          x="0"
                          y="0"
                          width="36"
                          height="36"
                          filterUnits="userSpaceOnUse"
                          color-interpolation-filters="sRGB"
                        >
                          <feFlood
                            flood-opacity="0"
                            result="BackgroundImageFix"
                          />
                          <feColorMatrix
                            in="SourceAlpha"
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            result="hardAlpha"
                          />
                          <feOffset dy="1" />
                          <feGaussianBlur stdDeviation="1" />
                          <feComposite in2="hardAlpha" operator="out" />
                          <feColorMatrix
                            type="matrix"
                            values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
                          />
                          <feBlend
                            mode="normal"
                            in2="BackgroundImageFix"
                            result="effect1_dropShadow_10095_100279"
                          />
                          <feBlend
                            mode="normal"
                            in="SourceGraphic"
                            in2="effect1_dropShadow_10095_100279"
                            result="shape"
                          />
                        </filter>
                        <clipPath id="clip0_10095_100279">
                          <rect
                            width="16"
                            height="16"
                            fill="white"
                            transform="translate(10 9)"
                          />
                        </clipPath>
                      </defs>
                    </svg>
                  </div>

                  <Typography
                    fontSize={"19px"}
                    fontWeight={700}
                    color={"#101828"}
                  >
                    {"Recommendations"}
                  </Typography>
                </CommonGrid2>

                <Typography
                  fontSize={"15px"}
                  fontWeight={700}
                  marginLeft={"10px"}
                  marginTop={"10px"}
                >
                  1. Add a Retail Operations Lead
                </Typography>

                <ul style={{ marginTop: "0px" }}>
                  <li style={{ color: "#344054", fontSize: "15px" }}>
                    Ensures store associates, fulfillment workflows, and
                    inventory reality are built into design.
                  </li>
                </ul>

                <Typography
                  fontSize={"15px"}
                  fontWeight={700}
                  marginLeft={"10px"}
                >
                  2. Supplement with a Personalization/AI Specialist
                </Typography>
                <ul style={{ marginTop: "0px" }}>
                  <li style={{ color: "#344054", fontSize: "15px" }}>
                    Elevates data usage from reporting → real-time customer
                    value creation.
                  </li>
                </ul>
                <Typography
                  fontSize={"15px"}
                  fontWeight={700}
                  marginLeft={"10px"}
                >
                  3. Formalize Decision Rights
                </Typography>

                <ul style={{ marginTop: "0px" }}>
                  <li style={{ color: "#344054", fontSize: "15px" }}>
                    Clearly define when vision (Zahir) vs execution (Jacob/Lana)
                    wins to avoid tension
                  </li>
                </ul>
              </CustomDiv>
            </CommonGrid2>
          </CommonGrid2>
        </>
      ),
    },
    // { title: "Skill-Experience Matrix", component: <ScatterPlot /> },
    {
      title: "Skill-Experience Matrix",
      component: (
        <CommonGrid2
          container
          spacing={3}
          border={"1px solid #EAECEE"}
          padding={"20px 0px"}
          borderRadius={"10px"}
        >
          <CommonGrid2
            size={12}
            display={"flex"}
            justifyContent={"center"}
            padding={"10px 0px"}
          >
            <JigsawSkillsExperienceMatrix />
          </CommonGrid2>
        </CommonGrid2>
      ),
    },
    {
      title: "Disc Personality Assessment",
      component: (
        <>
          <CommonGrid2
            container
            spacing={3}
            border={"1px solid #EAECEE"}
            padding={"20px 0px"}
            borderRadius={"10px"}
          >
            <CommonGrid2
              size={12}
              display={"flex"}
              justifyContent={"center"}
              padding={"10px 0px"}
            >
              <DiscIco />
            </CommonGrid2>
          </CommonGrid2>{" "}
        </>
      ),
    },
    {
      title: "Candidate Proximity Insight",
      component: <CandidateProximityInsight />,
    },
    { title: "Skills", component: <Skills /> },
    {
      title: "Interactions",
      component: (
        <Interactions
          interactionHeaderData={interactionHeaderData}
          handleInteractionAction={setInterActionData}
        />
      ),
    },
  ];

  return (
    <Grid2 container spacing={3}>
      <Grid2 size={12}>
        <CommonGrid2 display={"flex"} gap={"1rem"} alignItems={"center"}>
          <CustomDiv>
            <CandidateChatBot style={{ width: "50px", height: "50px" }} />
          </CustomDiv>

          <CommonGrid2 display={"flex"} flexDirection={"column"} gap={"3px"}>
            <Typography variant="body3" fontWeight={600}>
              {`Here is my analysis of the Team`}
            </Typography>

            <CommonGrid2 display={"flex"} gap={"10px"} alignItems={"center"}>
              <Typography variant="div" fontWeight={500}>
                {"Analysis Score"}
              </Typography>

              <Typography
                variant="subtitle1"
                border={"1px solid #AAEFC6"}
                backgroundColor={"#ECFDF3"}
                color={"#067647"}
                padding={"2px 10px"}
                borderRadius={"50px"}
                fontWeight={600}
              >
                {"75–80% - Probability of Success"}
              </Typography>
              <CandidateFitIco />
            </CommonGrid2>
          </CommonGrid2>
        </CommonGrid2>

        {accordionDataView.map((item, index) => (
          <CustomAccordion
            ContentMargin={"0px !important"}
            paddingBottom={"1rem"}
            defaultExpanded
          >
            <AccordionSummary
              expandIcon={<ExpandIco />}
              aria-controls={`panel${index}-content`}
              id={`panel${index}-header`}
              onClick={(e) => {
                if (!e.target.closest(".expand-icon")) {
                  e.stopPropagation();
                }
              }}
              style={{ pointerEvents: "none" }}
            >
              <CommonGrid2
                display={"flex"}
                alignItems={"center"}
                justifyContent={"space-between"}
                size={12}
              >
                <Typography variant="h4" margin={"15px 0px"} fontWeight={600}>
                  {item.title}
                </Typography>
              </CommonGrid2>
            </AccordionSummary>
            <AccordionDetails>
              <Grid2 size={12}>{item.component}</Grid2>
            </AccordionDetails>
          </CustomAccordion>
        ))}
      </Grid2>
      <Grid2 size={12}>
        <CommonButton
          variant="outlined"
          color="#344054"
          border="#D0D5DD"
          fontWeight="700"
          value="Share"
          padding="8px 15px"
          marginTop={"0px"}
          onClick={() => setShareDialogOpen(true)}
        />
      </Grid2>
      <SummaryInteractionDialog
        open={interActionOpen}
        handleClose={() => setInterActionOpen(false)}
        interActionData={interActionData}
      />
      <ShareQuickMatch
        shareDialogOpen={shareDialogOpen}
        handleShareDialogClose={handleShareDialogClose}
        handleShareInvite={handleShareInvite}
        isLoading={isLoading}
      />
    </Grid2>
  );
}

export default JobsSummary;
